import { Box, Button, Checkbox, FormControlLabel, Grid, Grid2, IconButton, Modal, Paper, Snackbar, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import TokenError from "../tokenError";
import config from "../../config/config";
import {makeGetRequestToUrl, makePostRequestToUrl} from '../commonFunc.jsx';
import { useNavigate } from "react-router-dom";
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import CloseIcon from '@mui/icons-material/Close';
import { Label } from "flowbite-react";
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AnalyticsTabs } from '../../constant';
import {CustomSwitch} from '../ui/Toggle.jsx';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius:'8px'
};

const RolesAndPermissions = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const [tokenExpired, setTokenExpired] = useState(false);
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [rows, setRows] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('fleet_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [open, setOpen] = useState(false);
    const [edit, setEdit] = useState(false);
    const [active, setActive] = useState(true);
    const [activeTab, setActiveTab] = useState(true);
    const [roleName, setRoleName] = useState('');
    const [roleId, setRoleId] = useState('');
    const [tabs,setTabs] = useState([]);
    const [selectedTabs, setSelectedTabs] = useState('');
    const [analyticsTab, setAnalyticsTab] = useState([]);
    const [openDropdownTabId, setOpenDropdownTabId] = useState(null);
    const [openDropdownTabs, setOpenDropdownTabs] = useState({});
    const [rolepermission, setRolePermission] = useState([]);
    const [openTabModal, setOpenTabModal] = useState(false);
    const [selectedTabPermissions, setSelectedTabPermissions] = useState([]);
    const [rolesData, setRolesData] = useState({});
    const [userDetailsMasking, setUserDetailsMasking] = useState(false);
    const [driverDetailsMasking, setDriverDetailsMasking] = useState(false);
    const city_manager_enabled = localStorage.getItem('city_manager_enabled');
    const clientId = localStorage.getItem('clientId');
    

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    console.log(selectedTabs,"selected at")
    
    const handleSnackbarClose = () => {
        setSnackbar(false);
    };
    
    useEffect(() => {
        fetchRolesData();
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    
    const handleOpenAddRole = () => {
        setOpen(true);
        setEdit(false);
        setRoleName('');
        setActive(false);
        setRoleId('');
        setUserDetailsMasking(false);
        setDriverDetailsMasking(false);
        // Initialize an empty selectedTabs object or set all tabs to inactive
        const initialSelectedTabs = {};
        tabs.forEach(tab => {
            initialSelectedTabs[tab.tab_id] = 0; // Set all tabs to inactive (unchecked)
        });
        setSelectedTabs(initialSelectedTabs);
        setOpenDropdownTabs({});
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleOpenEdit = (row) => {
        setEdit(true);
        setOpen(true);
        setRoleName(row.name);
        setActive(row.is_active == 1);
        setRoleId(row.role_id);
        setUserDetailsMasking(row.hide_user_info);
        setDriverDetailsMasking(row.hide_driver_info);
        const activeTabIds = row.tabs
            .filter(row => row.is_active == 1)
            .map(row => row.tab_id); 
            setActiveTab(activeTabIds);
        
        // Store the tabs data
        
        // Initialize selectedTabs with main, permissions, and dropdownOpen
        const initialSelectedTabs = {};
        const initialOpenDropdownTabs = {};
        row.tabs.forEach(tab => {
            const tabData = {
                main: tab.is_active,
                view: tab.permissions?.includes('1') || true,
                edit: tab.permissions?.includes('2') || false,
                add: tab.permissions?.includes('3') || false,
                creditDebit: tab.permissions?.includes('4') || false,
            };
            
            // Special handling for shuttle analytics (tab_id 25) - store shuttle_analytics_reports
            if (tab.tab_id === 25 && tab.shuttle_analytics_reports) {
                tabData.shuttle_analytics_reports = tab.shuttle_analytics_reports;
                // Also store permissions array for modal
                if (tab.shuttle_analytics_reports) {
                    tabData.permissions = tab.shuttle_analytics_reports.split(',').map(id => parseInt(id.trim()));
                }
            }
            
            initialSelectedTabs[tab.tab_id] = tabData;
            initialOpenDropdownTabs[tab.tab_id] = tab.is_active == 1;
        });
        setSelectedTabs(initialSelectedTabs);
        setAnalyticsTab(row.tabs.filter(tab => tab.tab_id === 25));
        setOpenDropdownTabs(initialOpenDropdownTabs);
        setTabs(row.tabs);
    };

    const fetchRolesData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/panel/fetch_admin_roles';
            const url2 = serverUrl + '/panel/fetch_admin_tabs';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            const response2 = await makeGetRequestToUrl(url2, body);
            if(response.flag==200 && response2.flag==200){
                const fetchedData = response.data;
                setRows(fetchedData);
                setTabs(response2.data);
            }
            if(response.flag==102 || response2.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }
    useEffect(() => {
        fetchRolesData();
    }, []);

    const handlePermissionChange = (tabId, permission) => {
        setSelectedTabs((prev) => ({
            ...prev,
            [tabId]: {
                ...prev[tabId],
                [permission]: !prev[tabId]?.[permission],
            },
        }));
    };
      
      const handleChangeTabs = (tab_id) => {
        setSelectedTabs((prev) => {
            const currentTab = prev[tab_id] || { main: 0, view: false, edit: false, add: false,  };
            const isMainToggledOn = !currentTab.main || currentTab.main === 0;
    
            return {
                ...prev,
                [tab_id]: {
                    ...currentTab,
                    main: isMainToggledOn ? 1 : 0,
                    view: isMainToggledOn ? true : currentTab.view, // Reset permissions when toggling off
                    edit:  currentTab.edit || false,
                    add: currentTab.add || false,
                    // dropdownOpen: isMainToggledOn ? !currentTab.dropdownOpen : false, // Toggle dropdown only when main is on
                },
            };
        });
        setOpenDropdownTabs((prev) => ({
            ...prev,
            [tab_id]: !prev[tab_id], // Toggle dropdown open/close
        }));
    };
    const handleSubmit = async()=> {
        const changedTabs = [];
        const activeTabIds = [];
        let shuttleTabsArray = [];
        
        // Create formatted permissions object
        const formattedPermissions = {};
        
        // Loop through each tab
        for (const tab_id in selectedTabs) {
            const permissions = [];
            const tab = selectedTabs[tab_id];

                if (Number(tab_id) === 25) {
                    if (tab.main === 1) {
                        formattedPermissions[tab_id] = "1";
                        shuttleTabsArray = tab.permissions || [];
                    }
                    continue;
                }
            
            // Add permission numbers based on which ones are enabled
            if (tab.view === true) permissions.push("1");
            if (tab.edit === true) permissions.push("2");
            if (tab.add === true) permissions.push("3");
            if ((Number(tab_id) === 40 || Number(tab_id) === 1) && tab.creditDebit === true) permissions.push("4");
            
            // Only include tabs that have main=1 (active) and at least one permission
            if (tab.main === 1 && permissions.length > 0) {
                formattedPermissions[tab_id] = permissions.join(",");
            }
            
            if (selectedTabs[tab_id].main === 1) {
                activeTabIds.push(tab_id);
            }
        }
                
        if (Object.keys(formattedPermissions).length === 0) {
            setMessage("Please select at least one tab");
            setSnackbar(true);
            return;
        }
        
        // Create comma-separated string of active tab IDs
        // const tabStr = activeTabIds.join(",");
        const payload = {
            token: localStorage.getItem('token'),
            name: roleName,
            // is_active: active,
            tabs: formattedPermissions,
            // permissions: JSON.stringify(formattedPermissions)
        }
        if(city_manager_enabled == 1){
            payload.hide_user_info = userDetailsMasking ? 1 : 0;
            payload.hide_driver_info = driverDetailsMasking ? 1 : 0;
            payload.shuttle_analytics_reports = shuttleTabsArray.length
                ? {
                    25: shuttleTabsArray.join(",")
                    }
                : {};
        }
        if(edit){
            payload.role_id = roleId;
        }
        try {
            const url = operationsUrl + '/panel/add_update_admin_roles_and_permissions';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                setSnackbar(true);
                setOpen(false);
                fetchRolesData();

            } else {
                setMessage(response.message)
                setSnackbar(true);
            }

        } catch (error) {
            console.error('Error', error);
            setMessage(error);
        }
    }

    const setEnabled = async(row, val) => {
        try {
            const token = localStorage.getItem('token');
            const body = {
                token: token,
                // name: name,
                is_active: val,
                role_id: row.role_id,
            };
            if(row.role_id==1){
                setMessage('This is the default role. You cannot disable it.');
                setSnackbar(true);
                return;
            }

            const response = await fetch(operationsUrl + '/panel/add_update_admin_roles_and_permissions', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });
            const data = await response.json();

            if (data.flag==200) {
                fetchRolesData();
                setMessage(data.message);
                setSnackbar(true);
            } 
            else {
                setMessage(data.message || 'Login failed. Please try again.');
                setSnackbar(true);
            }
        } catch (error) {
            setErrorMessage('An error occurred. Please try again later.');
        }
    }

    return(
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Roles & Permissions
            </Typography>

            <Grid2 container spacing={2} alignItems="center" style={{ marginTop: '2%', marginBottom: '2%' }}>
                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddRole}
                        style={{
                            width: '185px',
                            height: '50px',
                            backgroundColor: '#000000',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        + Add Role
                    </Button>
                </Grid2>
            </Grid2>

            <div style={{position: 'fixed',top: 65,right: open ? 0 : '-100%',height: '100%', width: '69%', backgroundColor: '#f9f9f9',boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',zIndex: 1000,overflowY: 'auto',padding: 20}}>
                <Box onClose={handleClose} editMode={edit}>
                    <div style={{ position: 'relative', padding: '40px 0' }}>
                        <IconButton aria-label="close" onClick={handleClose}
                            style={{ position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10,}}
                        >
                            <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                        </IconButton>
                        <Paper elevation={3}
                            style={{ padding: '30px', maxWidth: '1000px', margin: '0 auto',
                                backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                            <Typography style={{ marginBottom: '20px', fontWeight: '500', fontSize:'24px' }}>
                                {edit ? 'Edit Role' : 'Add Role'}
                            </Typography>

                            <Grid2>
                                <Label>Role Name<span style={{ color: 'red' }}>*</span></Label>
                                <TextField  sx={{marginTop:'1%'}}
                                    placeholder="Role Name" fullWidth variant="outlined" type="text" value={roleName}
                                    onChange={(e) => setRoleName(e.target.value)}
                                    InputProps={{
                                        inputProps: { min: 0 }, // Prevent values less than zero
                                        style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                    }}
                                />
                            </Grid2>
                            <Grid2 sx={{display:'flex',gap:"10px"}}>

                            {city_manager_enabled == 1 && <Grid2 sx={{mt:2}}>
                                User Details Masking :- 
                                <CustomSwitch 
                                    checked={userDetailsMasking || clientId == 1}
                                    backgroundtheme={userDetailsMasking ? "#0065FF" : "#8ffabc"}
                                    onChange={(e) => setUserDetailsMasking(e.target.checked)}
                                    disabled={clientId == 1}
                                    />
                            </Grid2>}
                            {city_manager_enabled == 1 && <Grid2 sx={{mt:2}}>
                                Driver Details Masking :- 
                                <CustomSwitch 
                                    checked={driverDetailsMasking || clientId == 1}
                                    backgroundtheme={driverDetailsMasking ? "#0065FF" : "#8ffabc"}
                                    onChange={(e) => setDriverDetailsMasking(e.target.checked)}
                                    disabled={clientId == 1}
                                    />
                            </Grid2>}
                                    </Grid2>

                            <Grid2 sx={{marginTop:'3%'}}>
                                <Label>Select Tabs<span style={{ color: 'red' }}>*</span></Label>
                                <Grid container spacing={0.8} sx={{ marginTop: '0%',overflowY:'auto' ,display:'flex',flexDirection:'column'}}>
                                <Box
                                    sx={{
                                        columnCount: 3, 
                                        gap:10,
                                        columnGap: '10px',
                                        padding:'10px',
                                        // maxHeight: '400px', // Limit height to enable scrolling if needed
                                        // overflowY: 'auto',
                                    }}
                                >
                                {tabs.map((tab) => (
                                    <Paper
                                    key={tab.tab_id}
                                    sx={{
                                      borderRadius: '8px',
                                      breakInside: 'avoid', // Prevent the Paper from breaking across columns
                                      display: 'flex',
                                      flexDirection: 'column',
                                      padding:'0px',
                                      marginBottom:'4%',
                                      width: '100%',
                                    }}
                                  >
                                        <Grid item xs={12} key={tab.tab_id} sx={{ border: '1px solid #E0E0E0', marginBottom:'0%', borderRadius: '8px', width: '100%' }}>
                                            <Box display="flex" justifyContent="space-between" alignItems="center" style={{marginLeft:"10px"}}>
                                            <Typography>{tab.tab_label}</Typography>
                                            <Checkbox
                                                checked={!!selectedTabs[tab.tab_id]?.main}
                                                onChange={() => {
                                                    handleChangeTabs(tab.tab_id);
                                                    setOpenDropdownTabId(openDropdownTabId == tab.tab_id ? null : tab.tab_id);
                                                }}        
                                                disabled={roleId == 1}
                                                />
                                        </Box>
                                        {  openDropdownTabs[tab.tab_id] && (
                                            <Grid2 sx={{
                                                borderRadius: '6px',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                marginLeft: '4px',
                                                gap: '20px',
                                                flexWrap: 'nowrap',
                                                overflowX: 'auto',
                                                maxWidth: '330px',
                                                pb: '4px',
                                                '& > *': { flexShrink: 0 },
                                            }}>
                                                <Typography sx={{ color: '#83888E',display:'flex',alignItems:'center' }}>
                                                    <Checkbox
                                                        checked={!!selectedTabs[tab.tab_id]?.view}
                                                        onChange={() => handlePermissionChange(tab.tab_id, 'view')}
                                                        disabled={!!selectedTabs[tab.tab_id]?.main || roleId == 1}
                                                        />View
                                                </Typography>
                                                {(tab.tab_id == 1 || tab.tab_id == 40) &&(
                                                    <>
                                                    <Typography sx={{ color: '#83888E',display:'flex',alignItems:'center' }}>
                                                    <Checkbox
                                                        checked={!!selectedTabs[tab.tab_id]?.edit}
                                                        onChange={() => handlePermissionChange(tab.tab_id, 'edit')}
                                                        disabled={roleId == 1}
                                                        />Edit
                                                    </Typography>
                                                    <Typography sx={{ color: '#83888E',display:'flex',alignItems:'center' }}>
                                                        <Checkbox
                                                        checked={!!selectedTabs[tab.tab_id]?.add}
                                                        onChange={() => handlePermissionChange(tab.tab_id, 'add')}
                                                        disabled={roleId == 1}
                                                        />Add
                                                    </Typography>
                                                    </>
                                                )}
                                                {(tab.tab_id == 1 || tab.tab_id == 40) &&(
                                                    <>
                                                    <Typography sx={{ color: '#83888E',display:'flex',alignItems:'center' }}>
                                                    <Checkbox
                                                        checked={!!selectedTabs[tab.tab_id]?.creditDebit}
                                                        onChange={() => handlePermissionChange(tab.tab_id, 'creditDebit')}
                                                        disabled={roleId == 1}
                                                        />Credit/Debit
                                                    </Typography>
                                                    </>
                                                )}


                                                {(tab.tab_id == 25) && city_manager_enabled == 1 && (
                                                    <>
                                                    <Typography sx={{ color: '#83888E',display:'flex',alignItems:'center' }}>
                                                    <Checkbox
                                                        checked={(selectedTabs[tab.tab_id]?.permissions && selectedTabs[tab.tab_id]?.permissions.length > 0) || clientId == 1}
                                                        onChange={() => {
                                                            setOpenTabModal(true);
                                                            setSelectedTabPermissions(selectedTabs[tab.tab_id]?.permissions || []);
                                                        }}
                                                        disabled={clientId == 1}
                                                        />Manage Tabs
                                                    </Typography>
                                                    </>
                                                )}
                                            </Grid2>
                                        )}
                                    </Grid>
                                    </Paper>
                                ))}
                                </Box>
                            </Grid>
                            </Grid2>

                            <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: '6%' }}>
                                {roleId!=1 &&
                                    <Button variant="contained"
                                        onClick={handleSubmit}
                                        sx={{
                                            width: '140px',height: '50px', textTransform: 'none',fontSize: '16px',
                                            backgroundColor: '#0065FF',color: 'white',
                                        }}
                                    >
                                        {edit ? 'Update' : 'Save'}
                                    </Button>
                                }
                                
                                <Button
                                    variant="contained"
                                    onClick={handleClose}
                                    sx={{
                                        width: '140px',height: '50px',textTransform: 'none',
                                        fontSize: '16px',backgroundColor: '#F0F0F0',color: '#B0B0B0'
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </Paper>
                    </div>
                </Box>
            </div>

            <TableContainer className="table-container" sx={{minHeight:'70vh'}}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell component="th" align="center" className="table-header" style={{ width: '12%' }}>
                                <TableSortLabel
                                    active={orderBy === 'fleet_id'}
                                    direction={orderBy === 'fleet_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('fleet_id')}
                                >
                                    ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '20%' }}>Name</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Analytics Tabs</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Status</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row) => {

                                return(
                                    <TableRow key={row.role_id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.role_id}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.name}</Typography></TableCell>
                                    <TableCell align="center">
                                        <Typography sx={{ 
                                            width: 'auto', 
                                            minWidth: '100px',
                                            color: row.tabs && row.tabs.some(tab => tab.tab_id === 25 && tab.shuttle_analytics_reports) ? '#0DBA78' : '#D14545',
                                            fontWeight: '500'
                                        }}>
                                            {row.tabs && row.tabs.some(tab => tab.tab_id === 25 && tab.shuttle_analytics_reports) ? 'Enabled' : 'Disabled'}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <div style={{ display: 'flex', justifyContent:'center'}}>
                                            <Button variant="contained" onClick={() => setEnabled(row,1)}
                                                style={{
                                                    backgroundColor: row.is_active ? '#0DBA78' : '#F4F4F4', minWidth: '80px',padding: '6px 16px',
                                                    color:row.is_active?'#FFFFFF':'#9E9E9E',textTransform:'none',borderRadius:'8px 0 0 8px', boxShadow: 'none',
                                                }}
                                            >
                                                Enable
                                            </Button>
                                            <Button variant="contained" onClick={() => setEnabled(row, 0)}
                                                style={{
                                                    backgroundColor: !row.is_active ? '#D14545' : '#F4F4F4', color: !row.is_active ? '#FFFFFF' : '#9E9E9E',
                                                    textTransform:'none', borderRadius:'0 8px 8px 0', boxShadow:'none',padding:'6px 16px', minWidth:'80px',
                                                }}
                                            >
                                                Disable
                                            </Button>
                                        </div>
                                    </TableCell>
                                    {/* <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color: row.is_active === 1 ? '#0DBA78' : '#D14545', fontWeight:'500' }}>{row.is_active==1 ? 'Active' : 'Inactive'}</Typography></TableCell> */}
                                    <TableCell align="center">
                                        {row.role_id!=1 && 
                                            <Button
                                                variant="contained"
                                                onClick={() => handleOpenEdit(row)}
                                                sx={{
                                                    backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                    borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                                    '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                    '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                                }}>
                                                
                                                <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                                    <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                                </svg>
                                            </Button>
                                        }

                                        {row.role_id==1 &&
                                            <Button variant="contained" onClick={() => handleOpenEdit(row)} sx={{backgroundColor:'#fff', border:'1px solid #0065ff', borderRadius: '8px', width:"90px", textTransform:'none', boxShadow:'none'}}>
                                                <Typography sx={{color:'#0065ff'}}>View</Typography>
                                            </Button>
                                        }
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
                
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                    <button
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                        className="pagination-arrow"
                    >
                        <img src={prevIcon} alt="Previous" />
                    </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${ page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
            
            {/* Tab Permissions Modal */}
            <Modal
                open={openTabModal}
                onClose={() => setOpenTabModal(false)}
                aria-labelledby="tab-permissions-modal"
                aria-describedby="tab-permissions-description"
            >
                <Box sx={style}>
                    <Typography variant="h6" component="h2" sx={{ marginBottom: 2 }}>
                        Manage Tab Permissions
                    </Typography>
                    
                    <Box sx={{ maxHeight: 300, overflowY: 'auto' }}>
                        <Grid container spacing={2}>
                            {Object.entries(AnalyticsTabs).map(([key, value]) => (
                                <Grid item xs={12} sm={9} md={6} key={key}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={selectedTabPermissions.includes(Number(key))}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setSelectedTabPermissions([...selectedTabPermissions, Number(key)]);
                                                    } else {
                                                        setSelectedTabPermissions(selectedTabPermissions.filter(id => id !== Number(key)));
                                                    }
                                                }}
                                            />
                                        }
                                        label={value}
                                        sx={{ 
                                            marginBottom: 1,
                                            alignItems: 'center',
                                            marginLeft: 0
                                        }}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                    
                    <Box sx={{ marginTop: 3, display: 'flex', justifyContent: 'flex-end', gap: 2,color:"#0065FF" }}>
                        <Button 
                            onClick={() => setOpenTabModal(false)}
                            sx={{ marginRight: 1 }}
                        >
                            Cancel
                        </Button>
                        <Button 
                            // variant="contained"
                            onClick={() => {
                                // Update selectedTabs with new permissions
                                const updatedTabs = {
                                    ...selectedTabs,
                                    25: {
                                        ...selectedTabs[25],
                                        permissions: selectedTabPermissions,
                                        edit: selectedTabPermissions.length > 0
                                    }
                                };
                                setSelectedTabs(updatedTabs);
                                setOpenTabModal(false);
                            }}
                            sx={{background:'#0065FF',color:"#fff"}}
                        >
                            Update
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </div>
    )
}

export default RolesAndPermissions;